import React, { useState, useEffect } from "react";
import NhanVayApi from "service/nhanVayApi";
import { getDate } from "utils/formatDate";
import Pagination from "react-js-pagination";
import { formatNumber } from "utils/currencyFormat";

export const LichSuGiaHan = ({ NhanVayId }) => {
  useEffect(() => {
    DanhSachLichSuGiaHan(1);
  }, []);
  const dataInit = {
    List: [],
    TongBanGhi: 0,
    TongTienPhaiThanhToan: 0,
  };
  const [dataLichSuGiaHan, UpdateDataLichSuGiaHan] = useState(dataInit);
  const [pageIndex, setPageIndex] = useState(1);
  const DanhSachLichSuGiaHan = (page) => {
    NhanVayApi.lichSugiaHanNgayTra(NhanVayId, page, 5).then((response) => {
      UpdateDataLichSuGiaHan({
        ...dataLichSuGiaHan,
        List: response.data.List,
        TongBanGhi: response.data.TongBanGhi,
        TongTienPhaiThanhToan: response.data.TongTienPhaiThanhToan,
      });
    });
  };
  const PhanTrang = (index) => {
    setPageIndex(index);
    DanhSachLichSuGiaHan(index);
  };

  const listItem = () => {
    return dataLichSuGiaHan.List.map((item, index) => {
      return (
        <>
          <tr>
            <th className="w-stt">
              <span className="w-stt">{index + 1}</span>
            </th>
            <th className="w-date"> {getDate(item.GiaHanChoKy)}</th>
            <th className="w-date">{getDate(item.NgayGiaHan)}</th>
            <th className="text-right w-15">
              {formatNumber(item.SoTienPhaiThanhToan)}
            </th>
            <th className="w-date">{getDate(item.NgayPhaiThanhToan)}</th>
            <th className="text-left"> {item.LyDo}</th>
          </tr>
        </>
      );
    });
  };
  return (
    <>
      <div
        id="headingCollapse640"
        className="card-header border-info mt-1"
        href="#collapse640"
        aria-expanded="true"
        aria-controls="collapse640"
      >
        <a className="card-title lead info collapsed" href={() => false}>
          <h3>Lịch sử gia hạn</h3>
        </a>
      </div>
      <div
        id="collapse640"
        aria-labelledby="headingCollapse640"
        className="card-collapse collapse show"
        aria-expanded="true"
      >
        <div className="card-content mt-1">
          <div className="card-body">
            <div className="table-responsive table-2">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th className="w-stt">
                      <span className="w-stt">STT</span>
                    </th>
                    <th className="w-date">Gia hạn cho Kỳ</th>
                    <th className="w-date">Ngày gia hạn</th>
                    <th className="text-right w-15">
                      Số tiền phải thanh toán
                      <br />
                      <span className="red">
                          {" "}
                        {dataLichSuGiaHan.TongTienPhaiThanhToan}
                      </span>
                    </th>
                    <th className="w-date">Ngày phải thanh toán</th>
                    <th className="text-left">Lý do gia hạn</th>
                  </tr>
                </thead>
                <tbody>{listItem()}</tbody>
              </table>
            </div>
            {/* <div className="footer-page-new">
              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  <div className="paniation-new d-flex justify-content-center">
                    <nav aria-label="Page navigation">
                      <Pagination
                        activePage={1}
                        itemsCountPerPage={15}
                        totalItemsCount={10}
                        pageRangeDisplayed={5}
                        // onChange={handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                        activeClass="active"
                      />
                    </nav>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};
